import MenuNames from "../../../constants/Menu/MenuNames.json";
import FleetCoachAppReleases from "../../../views/FleetCoachAppReleases";
import FleetCoachAppReleasesV2 from "../../../views/FleetCoachAppReleasesV2";

const FleetCoachAppReleasesRoutes = [
  {
    menuName: MenuNames.FLEET_COACH_APP_RELEASE,
    path: "/fleet-coach-app-releases",
    component: FleetCoachAppReleases,
    exact: true,
  },
  {
    menuName: MenuNames.FLEET_COACH_APP_RELEASE_V2,
    path: "/v2/fleet-coach-app-releases",
    component: FleetCoachAppReleasesV2,
    exact: true,
  },
];

export default FleetCoachAppReleasesRoutes;
